import mapboxgl from 'mapbox-gl'
import i18n from "../../i18n";

export class PatientPopup extends mapboxgl.Popup {
  constructor(filterCallback, openTableCallback, editTableCallback, hasEditorRole, options) {
    let popupOptions = {
      ...options,
      closeOnMove: false,
      closeOnClick: true,
      closeButton: true,
      className: 'patient-popup',
      maxWidth: '300px'
    }
    super(popupOptions)
    this._filterCallback = filterCallback
    this._openTableCallback = openTableCallback
    this._editTableCallback = editTableCallback
    this._hasEditorRole = hasEditorRole
  }
  filterMap(patientId) {
    this._filterCallback(patientId)
    this.remove()
  }
  openTable(patientId) {
    this._openTableCallback(patientId)
    this.remove()
  }
  editTable(patientId) {
    this._editTableCallback(patientId)
    this.remove()
  }
  addPatientToList(control, patient) {
    let row = document.createElement('div')
    row.className = "patient-popup-row"
    let patientName = document.createElement('span')
    patientName.className = "patient-popup-name"
    patientName.innerHTML = patient.azon
    let filterMapButton = document.createElement('span')
    filterMapButton.className = "patient-filter-map v-icon notranslate mdi mdi-map-marker"
    filterMapButton.title = `${i18n.t('Contacts')}`
    filterMapButton.addEventListener('click', (e) => { this.filterMap(patient._id); e.stopPropagation(); return false; })
    let tableViewButton = document.createElement('span')
    tableViewButton.className = "patient-table-view v-icon notranslate mdi mdi-note"
    tableViewButton.title = `${i18n.t('Editor')}`
    tableViewButton.addEventListener('click', (e) => { this.openTable(patient._id); e.stopPropagation(); return false; })
    let tableEditButton = document.createElement('span')
    tableEditButton.className = "patient-table-view v-icon notranslate mdi mdi-pencil"
    tableEditButton.title = `${i18n.t('Update')}`
    tableEditButton.addEventListener('click', (e) => { this.editTable(patient._id); e.stopPropagation(); return false; })
    row.appendChild(patientName)
    row.appendChild(filterMapButton)
    row.appendChild(tableViewButton)
    if (this._hasEditorRole) {
      row.appendChild(tableEditButton)
    }
    control.appendChild(row)
  }
  generatePatientControl(patients) {
    let control = document.createElement('div')
    control.className = "patient-popup-content"
    let header = document.createElement('div')
    header.className = "patient-popup-header"
    header.innerText = `${i18n.t('Persons')}:`
    let tableContainer = document.createElement('div')
    tableContainer.className = "patient-popup-table-container"
    let table = document.createElement('div')
    table.className = "patient-popup-table"
    control.appendChild(header)
    for (let patient of patients) {
      this.addPatientToList(table, patient)
    }
    tableContainer.appendChild(table)
    control.appendChild(tableContainer)
    return control
  }
  open(map, coordinate, patients) {
    if (this.isOpen()) {
      this.remove()
    }
    if (patients.length >= 1) {
      let control = this.generatePatientControl(patients)
      this.setDOMContent(control)
      this.setLngLat(coordinate)
      this.addTo(map)
    }
  }
}
